import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import toast, { Toaster } from 'react-hot-toast';
import ExportButton from '../components/ExportButton';
import VoiceSearchButton from '../components/VoiceSearchButton';
import { useAuth } from '../context/AuthContext';

export default function Customers() {
  var { user } = useAuth();
  var isAdmin = user && user.role === 'admin';
  var _cust = useState([]), customers = _cust[0], setCustomers = _cust[1];
  var _search = useState(''), search = _search[0], setSearch = _search[1];
  // Click-to-sort state, as requested.
  var _sort = useState({ key: 'client_number', dir: 'desc' }), sort = _sort[0], setSort = _sort[1];

  useEffect(function() { fetchCustomers(); }, []);

  function fetchCustomers(s) {
    api.get('/customers?search=' + (s || '')).then(function(r) { setCustomers(r.data); }).catch(console.error);
  };

  function handleSearch(e) {
    e.preventDefault();
    fetchCustomers(search);
  };

  function handleDelete(id) {
    if (!window.confirm('Delete this customer?')) return;
    api.delete('/customers/' + id).then(function() {
      toast.success('Customer deleted!');
      fetchCustomers();
    }).catch(function(err) { toast.error(err.response?.data?.error || 'Failed'); });
  };

  function handleSort(key) {
    setSort(function(prev) {
      if (prev.key === key) return { key: key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      return { key: key, dir: 'asc' };
    });
  }

  function sortIndicator(key) {
    if (sort.key !== key) return '';
    return sort.dir === 'asc' ? ' \u25B2' : ' \u25BC';
  }

  var columns = [
    { key: 'client_number', label: 'Client #', sortable: true },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'phone1', label: 'Phone', sortable: true },
    { key: 'area', label: 'Area', sortable: true },
    { key: 'reference_name', label: 'Reference', sortable: true },
    { key: 'collateral_type', label: 'Collateral', sortable: true }
  ];

  var sortedCustomers = customers.slice().sort(function(a, b) {
    var av = a[sort.key], bv = b[sort.key];
    // client_number is stored as text but represents a number
    if (sort.key === 'client_number') { av = parseInt(av) || 0; bv = parseInt(bv) || 0; }
    else { av = (av || '').toString().toLowerCase(); bv = (bv || '').toString().toLowerCase(); }
    if (av < bv) return sort.dir === 'asc' ? -1 : 1;
    if (av > bv) return sort.dir === 'asc' ? 1 : -1;
    return 0;
  });

  return React.createElement('div', null,
    React.createElement(Toaster, { position: 'top-right' }),
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 24 } },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12 } },
        React.createElement('h2', { style: { fontSize: 24, fontWeight: 'bold', margin: 0 } }, 'Customers'),
        React.createElement(ExportButton, { apiUrl: '/api/customers', filename: 'customers.csv' })
      ),
      React.createElement(Link, { to: '/customers/new', style: { background: '#2563eb', color: 'white', padding: '8px 16px', borderRadius: 8, textDecoration: 'none' } }, '+ Add Customer')
    ),
    React.createElement('form', { onSubmit: handleSearch, style: { marginBottom: 16 } },
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        React.createElement('input', { type: 'text', value: search, onChange: function(e) { setSearch(e.target.value); }, placeholder: 'Search...', style: { flex: 1, padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } }),
        React.createElement(VoiceSearchButton, { onResult: function(transcript) { setSearch(transcript); fetchCustomers(transcript); } }),
        React.createElement('button', { type: 'submit', style: { padding: '10px 16px', background: '#4b5563', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer' } }, 'Search')
      ),
      search && React.createElement('button', { type: 'button', onClick: function() { setSearch(''); fetchCustomers(''); }, style: { marginTop: 6, padding: 0, background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: 13 } }, '✕ Clear search')
    ),
    React.createElement('div', { style: { background: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' } },
      React.createElement('table', { style: { width: '100%', borderCollapse: 'collapse' } },
        React.createElement('thead', null,
          React.createElement('tr', { style: { background: '#f9fafb' } },
            React.createElement('th', { style: { padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280' } }, 'Photo'),
            columns.map(function(col) {
              return React.createElement('th', {
                key: col.key,
                onClick: function() { handleSort(col.key); },
                style: { padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: sort.key === col.key ? '#2563eb' : '#6b7280', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }
              }, col.label + sortIndicator(col.key));
            }),
            React.createElement('th', { style: { padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280' } }, 'Actions')
          )
        ),
        React.createElement('tbody', null,
          sortedCustomers.map(function(c) {
            var imgSrc = c.photo_url ? window.UPLOAD_BASE + c.photo_url : null;
            return React.createElement('tr', { key: c.id, style: { borderBottom: '1px solid #e5e7eb' } },
              React.createElement('td', { style: { padding: '10px 16px' } },
                imgSrc
                  ? React.createElement('img', { src: imgSrc, alt: c.name, style: { width: 70, height: 70, borderRadius: '50%', objectFit: 'cover', border: '2px solid #3b82f6' }, onError: function(e) { e.target.style.display = 'none'; } })
                  : React.createElement('div', { style: { width: 70, height: 70, borderRadius: '50%', background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 35, color: '#9ca3af' } }, '\u{1F464}')
              ),
              React.createElement('td', { style: { padding: '10px 16px', fontWeight: 500 } }, c.client_number),
              React.createElement('td', { style: { padding: '10px 16px' } }, c.name),
              React.createElement('td', { style: { padding: '10px 16px' } }, c.phone1),
              // Empty string (not '-') for missing values: on mobile, an
              // empty cell collapses out of the card entirely via the
              // td:empty rule in index.css, instead of showing a row of
              // meaningless dashes for data that isn't there.
              React.createElement('td', { style: { padding: '10px 16px' } }, c.area || ''),
              // Fixes a real bug in the screenshot you sent: the header row
              // already listed "Reference" and "Collateral" columns, but
              // the actual data cells for them were never rendered — the
              // columns just showed blank for every row.
              React.createElement('td', { style: { padding: '10px 16px' } }, c.reference_name || ''),
              React.createElement('td', { style: { padding: '10px 16px' } }, c.collateral_type || ''),
              React.createElement('td', { style: { padding: '10px 16px' } },
                isAdmin
                  // Fixes the request that collectors should not be able to
                  // edit or delete a customer. This is also enforced
                  // server-side (PUT/DELETE /api/customers/:id are
                  // admin-only there too) so it can't be bypassed by
                  // calling the API directly.
                  ? React.createElement('div', { className: 'action-links', style: { display: 'flex', gap: 8, flexWrap: 'wrap' } },
                      React.createElement(Link, { to: '/customers/' + c.id + '/edit', style: { color: '#2563eb', textDecoration: 'none' } }, 'Edit'),
                      React.createElement('button', { onClick: function() { handleDelete(c.id); }, style: { color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', padding: 0 } }, 'Delete')
                    )
                  : React.createElement('span', { style: { color: '#9ca3af', fontSize: 13 } }, '\u2014')
              )
            );
          })
        )
      ),
      customers.length === 0 && React.createElement('div', { style: { textAlign: 'center', padding: 32, color: '#6b7280' } }, 'No customers')
    )
  );
}
